import { AI_CREDITS_EXCEEDED_TEXT, type AiCreditsResponse } from "@edu/shared";

/**
 * Слова полоски кредитов в боковой панели (решение владельца 08.09.2026).
 *
 * Отдельным файлом от самой полоски по тому же правилу, по которому разведены
 * слова и разметка у сочинения и у вычитки: строку правят, не читая JSX, и
 * проверяют её чистой функцией.
 *
 * ⚠️ **Ни токенов, ни моделей, ни долларов.** Кредит это условная единица, и
 * всё, что человеку про неё надо знать, он узнает по тому, как убывает полоска.
 * Слова «токен», «модель», «запрос», «доллар» и «себестоимость» сюда не едут ни
 * одним путём (скилл `teacher-texts`, правило 4), и это же проверяет тест рядом.
 *
 * ⚠️ **Расход тут показан, и правилу «в адрес преподавателя не считается
 * ничего» это не противоречит.** Правило про его РАБОТУ: покрытие программы,
 * пройденные темы, число проверенных домашек. Знаменатель здесь наш, а не его:
 * это размер выданного ресурса, а не норма выработки. Тот же довод записан у
 * `AiCreditsResponse` и у запаса знаков на экране озвучки.
 */

/** Подпись полоски. Соседняя полоска подписана «Хранилище», и форма та же. */
export const CREDITS_HEADING = "Кредиты ИИ";

/**
 * Подсказка под указателем: то, чего не говорят два числа сами по себе.
 *
 * Числа в строке заголовка стоят без единиц («120 / 1000»), потому что шире
 * сайдбара строка не бывает. Здесь они названы словами, и к ним добавлено то,
 * что из них не следует: месяц и день, когда кредиты будут снова.
 *
 * ⚠️ **У кончившихся кредитов слова те же, что у отказа кнопки**
 * (`AI_CREDITS_EXCEEDED_TEXT`). Два объяснения одного запрета заставляют искать
 * между ними разницу, а её нет.
 */
export function creditsTitleText(credits: AiCreditsResponse): string {
  if (credits.left === 0) return AI_CREDITS_EXCEEDED_TEXT;
  return `${CREDITS_HEADING}: занято ${credits.spent} из ${credits.quota} в этом месяце. Новые придут первого числа`;
}
